import { POST } from '@/utils/axios'

export const signIn = async formData =>
  await POST('/user-details/login', formData)
